import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import AOS from "aos";
import "aos/dist/aos.css";

// Preloader
import Preloader from "./components/Preloader/Preloader";

// SEO helper (NEW)
import SEO from "./components/SEO/SEO";

import Navbar from "./components/Navbar/Navbar";
import Hero from "./components/Hero/Hero";
import Services from "./components/Services/Services";
import About from "./components/About/About";
import Contact from "./components/Contact/Contact";
import Footer from "./components/Footer/Footer";
import BrandsCarousel from "./components/Brands/BrandsCarousel/BrandsCarousel";

import ProductsPage from "./Pages/ProductsPage/ProductsPage";

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    AOS.init({ duration: 800, easing: "ease-out-cubic", once: true });

    const started = Date.now();
    const MIN_MS = 400;
    let timer;

    const done = () => {
      const left = Math.max(0, MIN_MS - (Date.now() - started));
      timer = setTimeout(() => setLoading(false), left);
    };

    if (document.readyState === "complete") done();
    else window.addEventListener("load", done, { once: true });

    return () => {
      window.removeEventListener("load", done);
      if (timer) clearTimeout(timer);
    };
  }, []);

  return (
    <Router>
      <Preloader show={loading} />

      <Routes>
        {/* HOME */}
        <Route
          path="/"
          element={
            <>
              <SEO
                title="New Alubomulla Trade Center | Hardware, Tools & Construction Materials"
                description="New Alubomulla Trade Center (Alubomulla Hardware) – your trusted hardware shop for construction materials and tools: cement, paint, roofing, electrical & plumbing items, fittings, hand tools and power tools."
                canonical="https://www.newalubomullatradecenter.com/"
              />

              <Navbar />
              <Hero />
              <Services />
              <BrandsCarousel />
              <About />
              <Contact />
              <Footer />
            </>
          }
        />

        {/* PRODUCTS */}
        <Route
          path="/products"
          element={
            <>
              <SEO
                title="Products | New Alubomulla Trade Center"
                description="Browse products at New Alubomulla Trade Center: hardware items, construction materials, tools, paint, electrical and plumbing supplies for building projects."
                canonical="https://www.newalubomullatradecenter.com/products"
              />

              <ProductsPage />
              <Footer />
            </>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
